export const questionsDK_Twelvesections = {
  "s-01": {
    "q-01": {
      title: "Udholdenhed er et vigtigt karaktertræk",

      category: "q-beStrong"
    },
    "q-02": {
      title:
        "Jeg kan godt lide at se folk gøre deres bedste for at få tingene gjort",

      category: "q-bePerfect"
    },
    "q-03": {
      title:
        "I betragtning af al den store indsats jeg lægger i ting, burde jeg få mere gjort",

      category: "q-tryHard"
    },
    "q-04": {
      title:
        "Jeg oplever mig selv gå i gang med at gøre for mange ting i sidste øjeblik",

      category: "q-hurryUp"
    },
    "q-05": {
      title:
        "Generelt tilpasser jeg mig mere til hvad andre ønsker, end hvad andre gør til mig",

      category: "q-pleasePeople"
    }
  },
  "s-02": {
    "q-06": {
      title: "Tilfældighed og skødesløshed irriterer mig",

      category: "q-beStrong",
      statement: 2
    },
    "q-07": {
      title:
        "Det interesserer mig mere at lave de samme ting end at afslutte dem",

      category: "q-bePerfect",
      statement: 2
    },
    "q-08": {
      title:
        "Når folk er langsomme til at sige noget, har jeg lyst afbryde eller afslutte sætningen",

      category: "q-tryHard",
      statement: 2
    },
    "q-09": {
      title:
        "Jeg har en ret god fantasi, med hensyn til at gætte eller fornemme hvad folk har brug for",

      category: "q-hurryUp",
      statement: 2
    },
    "q-10": {
      title:
        "Når nogen bliver følelsesladet, er min reaktion ofte at lave sjov med det, ellers være kritisk",

      category: "q-pleasePeople",
      statement: 2
    }
  },
  "s-03": {
    "q-11": {
      title:
        "Jeg har ikke noget imod, at tingene er svære. Jeg kan altid finde energien",

      category: "q-beStrong",
      statement: 3
    },
    "q-12": {
      title:
        "Jeg foretrækker at bruge den mindst mulig tid til at komme hen til et bestemt sted.",

      category: "q-bePerfect",
      statement: 3
    },
    "q-13": {
      title:
        "Hvis nogen ikke kan lide mig, prøver jeg virkelig at få dem til at ændre mening eller også undgår jeg dem",

      category: "q-tryHard",
      statement: 3
    },
    "q-14": {
      title: "Det er sjældent, at jeg føler mig såret",

      category: "q-hurryUp",
      statement: 3
    },
    "q-15": {
      title:
        "Hvis det er et spørgsmål om at gøre noget ordentligt, ville jeg hellere gøre det selv",

      category: "q-pleasePeople",
      statement: 3
    }
  },
  "s-04": {
    "q-16": {
      title: "Jeg bliver utålmodig med langsomme mennesker",

      category: "q-beStrong",
      statement: 4
    },
    "q-17": {
      title:
        "Normalt foretrækker jeg at tage folks ønsker i betragtning, inden jeg træffer beslutninger",

      category: "q-bePerfect",
      statement: 4
    },
    "q-18": {
      title: "Jeg viser et roligt ydre, selv når mine følelser er voldsomme",

      category: "q-tryHard",
      statement: 4
    },
    "q-19": {
      title: "Jeg accepterer ikke dårligt arbejde/kvalitet",

      category: "q-hurryUp",
      statement: 4
    },
    "q-20": {
      title:
        "Der er noget ved at afslutte en opgave som jeg ikke bryder mig om",

      category: "q-pleasePeople",
      statement: 4
    }
  },
  "s-05": {
    "q-21": {
      title: "Jeg gør en stor indsats i det jeg laver",

      category: "q-beStrong",
      statement: 5
    },
    "q-22": {
      title:
        "Nogle gange er det bedre bare at gøre noget og så gemme diskussionen til senere",

      category: "q-bePerfect",
      statement: 5
    },
    "q-23": {
      title: "Jeg er forsigtig med at bede andre om tjenester",

      category: "q-tryHard",
      statement: 5
    },
    "q-24": {
      title: "Jeg ønsker ikke folk tager hensyn til mig",

      category: "q-hurryUp",
      statement: 5
    },
    "q-25": {
      title: "Jeg har undertiden svært ved at ikke at rette på andre mennesker",

      category: "q-pleasePeople",
      statement: 5
    }
  },
  "s-06": {
    "q-26": {
      title: "Nogle gange snakker jeg for hurtigt",

      category: "q-beStrong",
      statement: 6
    },
    "q-27": {
      title:
        "Jeg får det ubehageligt, når folk er irriterede eller utilfredse med mig",

      category: "q-bePerfect",
      statement: 6
    },
    "q-28": {
      title: "Jeg bryder mig ikke om folk, der gør for meget ud af tingene",

      category: "q-tryHard",
      statement: 6
    },
    "q-29": {
      title: "Ting kan altid forbedres eller gøres bedre",

      category: "q-hurryUp"
    },
    "q-30": {
      title: "Jeg tror ikke på den 'lette' måde",

      category: "q-pleasePeople",
      statement: 6
    }
  },
  "s-07": {
    "q-31": {
      title: "Jeg synes at jeg gør meget for at tage hensyn til andre",

      category: "q-beStrong",
      statement: 7
    },
    "q-32": {
      title:
        "Jeg formår normalt at klare tingene, selv når jeg føler at jeg har fået mere end nok",

      category: "q-bePerfect",
      statement: 7
    },
    "q-33": {
      title:
        "Jeg foretrækker at gøre tingene rigtig godt, selvom det tager længere tid",

      category: "q-tryHard",
      statement: 7
    },
    "q-34": {
      title:
        "Jeg har en tendens til at starte tingene og derefter gradvis miste energi eller interesse",

      category: "q-hurryUp",
      statement: 7
    },
    "q-35": {
      title:
        "Jeg vil gerne gøre en hel masse ting færdige, og så løber jeg tør for tid",

      category: "q-pleasePeople",
      statement: 7
    }
  },
  "s-08": {
    "q-36": {
      title: "Jeg er ikke hvad man vil kalde ‘blød‘",

      category: "q-beStrong",
      statement: 8
    },
    "q-37": {
      title:
        "Jeg foretrækker at gøre tingene rigtigt første gang fremfor at gøre dem igen",

      category: "q-bePerfect",
      statement: 8
    },
    "q-38": {
      title:
        "Jeg gentager nogle gange mig selv, fordi jeg ikke er sikker på, om jeg er blevet forstået",

      category: "q-tryHard",
      statement: 8
    },
    "q-39": {
      title:
        "Min energi er ofte på det højeste, når jeg har en masse ting der skal gøres",

      category: "q-hurryUp",
      statement: 8
    },
    "q-40": {
      title:
        "Det er ret svært at sige nej, når nogen virkelig skal bruge noget",

      category: "q-pleasePeople",
      statement: 8
    }
  },
  "s-09": {
    "q-41": {
      title: "Jeg kan godt lide at bruge ord korrekt",

      category: "q-beStrong",
      statement: 9
    },
    "q-42": {
      title: "Jeg kan godt lide at undersøge alternativerne før jeg starter",

      category: "q-bePerfect",
      statement: 9
    },
    "q-43": {
      title:
        "Det er lige mig, at jeg allerede tænker på den næste ting, før jeg er færdig med den jeg er i gang med",

      category: "q-tryHard",
      statement: 9
    },
    "q-44": {
      title: "Når jeg er sikker på, at nogen kan lide mig, slapper jeg mere af",

      category: "q-hurryUp",
      statement: 9
    },
    "q-45": {
      title: "Jeg kan finde mig i meget uden at andre opdager det",

      category: "q-pleasePeople",
      statement: 9
    }
  },
  "s-10": {
    "q-46": {
      title: "Folk, der bare vil være hurtig færdig, irriterer mig",

      category: "q-beStrong",
      statement: 10
    },
    "q-47": {
      title:
        "Jeg foretrækker at bare kaste mig ud i noget fremfor at have en plan",

      category: "q-bePerfect",
      statement: 10
    },
    "q-48": {
      title:
        "Hvis en person ikke ved hvad jeg vil ha‘, vil jeg helst ikke spørge direkte",

      category: "q-tryHard",
      statement: 10
    },
    "q-49": {
      title: "Andre mennesker begynder at klynke og klage, før jeg gør det",

      category: "q-hurryUp",
      statement: 10
    },
    "q-50": {
      title:
        "Jeg foretrækker at rette mig selv fremfor at andre mennesker retter mig",

      category: "q-pleasePeople",
      statement: 10
    }
  },
  "s-11": {
    "q-51": {
      title: "Hvis jeg havde 20% mere tid, kunne jeg slappe mere af",

      category: "q-beStrong",
      statement: 11
    },
    "q-52": {
      title: "Jeg smiler og nikker ofte, når folk taler til mig",

      category: "q-bePerfect",
      statement: 11
    },
    "q-53": {
      title:
        "Når andre bliver ophidset kan jeg godt være meget kølig og rationel",

      category: "q-tryHard",
      statement: 11
    },
    "q-54": {
      title:
        "Jeg kan gøre noget godt og så stadig være kritisk overfor mig selv",

      category: "q-hurryUp",
      statement: 11
    },
    "q-55": {
      title:
        "Der er ofte så mange ting at tage højde for, at det kan være svært at afslutte noget",

      category: "q-pleasePeople",
      statement: 11
    }
  },
  "s-12": {
    "q-56": {
      title:
        "Jeg har en god intuitiv fornemmelse for hvorvidt nogen kan lide mig eller ej",

      category: "q-beStrong",
      statement: 12
    },
    "q-57": {
      title:
        "Jeg tror, pligt og fornuft lønner sig bedre i det lange løb end følelser gør",

      category: "q-bePerfect",
      statement: 12
    },
    "q-58": {
      title:
        "Jeg har en tendens til hurtigt at se, hvordan noget kan forbedres",

      category: "q-tryHard",
      statement: 12
    },
    "q-59": {
      title: "Nogle mennesker har for vane  at forsimple tingene",

      category: "q-hurryUp",
      statement: 12
    },
    "q-60": {
      title:
        "Nogle gange er det som om, at jo mere der er at gøre, jo mere får jeg gjort",

      category: "q-pleasePeople",
      statement: 12
    }
  }
};

export const questionsEN_Twelvesections = {
  "s-01": {
    "q-01": {
      title: "Endurance is a valuable asset",

      category: "q-beStrong",

      statement: 1
    },
    "q-02": {
      title: "I like to see people doing their best to get things done",

      category: "q-bePerfect",
      statement: 1
    },
    "q-03": {
      title:
        "Considering all the effort I put into things I should get more done",

      category: "q-tryHard",
      statement: 1
    },
    "q-04": {
      title: "I find myself doing  too many things at the last minute",

      category: "q-hurryUp",
      statement: 1
    },
    "q-05": {
      title:
        "On balance I adapt more to other peoples wishes than they do to mine",

      category: "q-pleasePeople",
      statement: 1
    }
  },
  "s-02": {
    "q-06": {
      title: "Casualness and carelessness bother me",

      category: "q-beStrong",
      statement: 2
    },
    "q-07": {
      title:
        "Its keeping on doing things that interest me more than finishing with them",

      category: "q-bePerfect",
      statement: 2
    },
    "q-08": {
      title:
        "When people are slow about saying something I want to interupt or finish the sentence",

      category: "q-tryHard",
      statement: 2
    },
    "q-09": {
      title:
        "I have a fair amount of imagination when it comes to guessing what people need",

      category: "q-hurryUp",
      statement: 2
    },
    "q-10": {
      title:
        "When someone gets emotional my reaction is often to make a joke of it or else be critical",

      category: "q-pleasePeople",
      statement: 2
    }
  },
  "s-03": {
    "q-11": {
      title: "I dont mind things being hard. I can always find the energy",

      category: "q-beStrong",
      statement: 3
    },
    "q-12": {
      title:
        "I prefer to use just the minimum necessary time to get to a place.",

      category: "q-bePerfect",
      statement: 3
    },
    "q-13": {
      title:
        "If someone doesnt like me I try hard to get them to like me or I walk away",

      category: "q-tryHard",
      statement: 3
    },
    "q-14": {
      title: "It is rare for me to feel hurt",

      category: "q-hurryUp",
      statement: 3
    },
    "q-15": {
      title:
        "If its a question of doing something properly I‘d rather do it myself",

      category: "q-pleasePeople",
      statement: 3
    }
  },
  "s-04": {
    "q-16": {
      title: "I get impatient with slow people",

      category: "q-beStrong",
      statement: 4
    },
    "q-17": {
      title:
        "Normally I prefer to take peoples wishes into account before deciding something",

      category: "q-bePerfect",
      statement: 4
    },
    "q-18": {
      title: "I show a calm face even when my feelings are running high",

      category: "q-tryHard",
      statement: 4
    },
    "q-19": {
      title: "I dont make excuses for poor work",

      category: "q-hurryUp",
      statement: 4
    },
    "q-20": {
      title: "Theres something about coming to the end of a job I dont like",

      category: "q-pleasePeople",
      statement: 4
    }
  },
  "s-05": {
    "q-21": {
      title: "I put a lot of effort into things",

      category: "q-beStrong",
      statement: 5
    },
    "q-22": {
      title:
        "Sometimes it is better to just do something and leave the discussion until later",

      category: "q-bePerfect",
      statement: 5
    },
    "q-23": {
      title: "Im cautious about asking favours",

      category: "q-tryHard",
      statement: 5
    },
    "q-24": {
      title: "I dont let people look after me much",

      category: "q-hurryUp",
      statement: 5
    },
    "q-25": {
      title: "I sometimes find it hard to stop myself from correcting people",

      category: "q-pleasePeople",
      statement: 5
    }
  },
  "s-06": {
    "q-26": {
      title: "Sometimes I talk too quickly",

      category: "q-beStrong",
      statement: 6
    },
    "q-27": {
      title: "Im uncomfortable when people are upset or displeased with me",

      category: "q-bePerfect",
      statement: 6
    },
    "q-28": {
      title: "I dislike peope making a fuss about things",

      category: "q-tryHard",
      statement: 6
    },
    "q-29": {
      title: "Things can always be improved on",

      category: "q-hurryUp",
      statement: 6
    },
    "q-30": {
      title: "I dont believe in the ‘easy‘ way",

      category: "q-pleasePeople",
      statement: 6
    }
  },
  "s-07": {
    "q-31": {
      title: "I think I do a lot to be considerate towards others",

      category: "q-beStrong",
      statement: 7
    },
    "q-32": {
      title:
        "I usually manage to cope even when I feel I‘ve had more than enough",

      category: "q-bePerfect",
      statement: 7
    },
    "q-33": {
      title: "I prefer doing things really well even if it takes longer",

      category: "q-tryHard",
      statement: 7
    },
    "q-34": {
      title:
        "I tend to start things and then gradually lose energy or interest",

      category: "q-hurryUp",
      statement: 7
    },
    "q-35": {
      title:
        "I want to get a whole lot of things finished, then I run out of time",

      category: "q-pleasePeople",
      statement: 7
    }
  },
  "s-08": {
    "q-36": {
      title: "Im not what you would call soft",

      category: "q-beStrong",
      statement: 8
    },
    "q-37": {
      title: "I prefer to do things right first time, than have to re-do them",

      category: "q-bePerfect",
      statement: 8
    },
    "q-38": {
      title:
        "I sometimes repeat myself because I‘m not sure I‘ve been understood",

      category: "q-tryHard",
      statement: 8
    },
    "q-39": {
      title:
        "My energy is often at its highest when I have a lot of things to do",

      category: "q-hurryUp",
      statement: 8
    },
    "q-40": {
      title: "It‘s quite hard to say no when someone really wants something",

      category: "q-pleasePeople",
      statement: 8
    }
  },
  "s-09": {
    "q-41": {
      title: "I like to use words correctly",

      category: "q-beStrong",
      statement: 9
    },
    "q-42": {
      title:
        "I like exploring a variety of alternatives before getting started",

      category: "q-bePerfect",
      statement: 9
    },
    "q-43": {
      title:
        "It‘s quite like me to be already thinking of the next thing before I have finished the first",

      category: "q-tryHard",
      statement: 9
    },
    "q-44": {
      title: "When I‘m sure someone likes me I am more at ease",

      category: "q-hurryUp",
      statement: 9
    },
    "q-45": {
      title: "I can put up with a great deal without anyone realising it",

      category: "q-pleasePeople",
      statement: 9
    }
  },
  "s-10": {
    "q-46": {
      title: "People who just want to finish something tend to irritae me",

      category: "q-beStrong",
      statement: 10
    },
    "q-47": {
      title: "I prefer to just plunge into something rather than have a plan",

      category: "q-bePerfect",
      statement: 10
    },
    "q-48": {
      title:
        "If a person doesn‘t know what I want I‘d rather not have to ask directly",

      category: "q-tryHard",
      statement: 10
    },
    "q-49": {
      title: "Other people start whining and complaining before I do",

      category: "q-hurryUp",
      statement: 10
    },
    "q-50": {
      title:
        "I prefer to correct myself rather that having other people correct me",

      category: "q-pleasePeople",
      statement: 10
    }
  },
  "s-11": {
    "q-51": {
      title: "If I had 20% more time I could relax more",

      category: "q-beStrong",
      statement: 11
    },
    "q-52": {
      title: "I often smile and nod when people talk to me ",

      category: "q-bePerfect",
      statement: 11
    },
    "q-53": {
      title: "When people get excited I can stay very cool and rational",

      category: "q-tryHard",
      statement: 11
    },
    "q-54": {
      title: "I can do something well and still be critical of myself",

      category: "q-hurryUp",
      statement: 11
    },
    "q-55": {
      title:
        "There are so many things to take into account it can be hard to get to the end of something",

      category: "q-pleasePeople",
      statement: 11
    }
  },
  "s-12": {
    "q-56": {
      title: "I have a good intuitive sense if someone likes me or not",

      category: "q-beStrong",
      statement: 12
    },
    "q-57": {
      title:
        "I think duty and reason pay off better than emotion in the long run",

      category: "q-bePerfect",
      statement: 12
    },
    "q-58": {
      title: "I tend to see quickly how something could be improved on",

      category: "q-tryHard",
      statement: 12
    },
    "q-59": {
      title: "Some people have a habit of oversimplifying things",

      category: "q-hurryUp",
      statement: 12
    },
    "q-60": {
      title:
        "Nogle gange er det som om, at jo mere der er at gøre, jo mere får jeg gjort",

      category: "q-pleasePeople",
      statement: 12
    }
  }
};

export const questionsDK_Drivers = {
  "q-01": {
    title: "Skjuler du eller styrer du dine følelser?",

    category: "q-beStrong"
  },
  "q-02": {
    title: "Er du tilbageholdende med at bede om hjælp?",

    category: "q-beStrong"
  },

  "q-03": {
    title:
      "Sætter du høje standarder for dig selv og kritiserer dig selv for ikke at møde dem?",

    category: "q-bePerfect"
  },

  "q-04": {
    title: "Gør du ting (især for andre) som du ikke rigtig har lyst til?",

    category: "q-pleasePeople"
  },

  "q-05": {
    title: "Har du tendens til at lave mange ting på en gang?",

    category: "q-hurryUp"
  },

  "q-06": {
    title:
      "Hader du at ‘give op‘ eller ‘give efter‘ og tænker altid ‘denne gang lykkedes det‘?",

    category: "q-tryHard"
  },

  "q-07": {
    title: "Er det vigtigt for dig at få RET?",

    category: "q-bePerfect"
  },

  "q-08": {
    title: "Er det vigtigt for dig at være VELLIDT?",

    category: "q-pleasePeople"
  },

  "q-09": {
    title: "Har du tendens til at starte ting og ikke fuldføre dem?",

    category: "q-tryHard"
  },

  "q-10": {
    title: "Sætter du dig selv urealistiske tidsfrister?",

    category: "q-tryHard"
  },

  "q-11": {
    title: "Er du nem at overtale?",

    category: "q-pleasePeople"
  },

  "q-12": {
    title: "Bryder du dig ikke om at være anderledes?",

    category: "q-pleasePeople"
  },

  "q-13": {
    title:
      "Har du tendens til at sætte dig selv i en position hvor andre er afhængige af dig?",

    category: "q-beStrong"
  },

  "q-14": {
    title:
      "Føler du ubehag (fx irriteret, irriteret) ved uorden eller unøjagtigheder som f.eks. en plet på en beklædningsgenstand eller væggen; en genstand eller noget værktøj der roder, en sjusket præsentation på arbejdet?",

    category: "q-bePerfect"
  },

  "q-15": {
    title:
      "Vil du beskrive dig selv som ‘hurtig‘ og oplever utålmodighed med andre?",

    category: "q-hurryUp"
  },
  "q-16": {
    title: "Hader du at blive afbrudt?",

    category: "q-bePerfect"
  },
  "q-17": {
    title:
      "Har du tendens til at sammenligne dig selv (eller dine resultater) med andres, og føler du dig i den sammenhæng ringere eller mere overlegen i den forbindelse?",

    category: "q-tryHard"
  },

  "q-18": {
    title:
      "Oplever du at du går rundt om dig selv, når du tumler med et problem og har følelsen af at være låst, men du kan ikke give slip?",
    category: "q-tryHard"
  },

  "q-19": {
    title:
      "Har du tendens til ikke at opdage hvor træt, hvor sulten eller hvor sløj du i virkeligheden er, men blot forsætter?",
    category: "q-beStrong"
  },

  "q-20": {
    title:
      "Har du tendens til tale i munden på andre, eller afslutte deres sætninger for dem?",
    category: "q-hurryUp"
  },

  "q-21": {
    title:
      "Foretrækker du at forklare ting i detaljen og med præsicion? Do you like to explain things in detail and precisely?",
    category: "q-bePerfect"
  },

  "q-22": {
    title:
      "Foretrækker du at ‘få tingene gjort‘ fremfor at diskutere/tale om tingene?",
    category: "q-hurryUp"
  },

  "q-23": {
    title: "Foretrækker du at gøre tingene selv?",
    category: "q-beStrong"
  },

  "q-24": {
    title: "Bryder du dig ikke om konflikter?",
    category: "q-pleasePeople"
  },

  "q-25": {
    title:
      "Har du tendens til at være oprøreren, udenfor eller den underlige i en gruppe?",
    category: "q-tryHard"
  }
};
export const questionsEN_Drivers = {
  "q-01": {
    title: "Do you hide or control your feelings?",

    category: "q-beStrong"
  },
  "q-02": {
    title: "Are you reluctant to ask for help?",

    category: "q-beStrong"
  },

  "q-03": {
    title:
      "Do you set yourself high standards and then critize yourself for failing to meet them?",

    category: "q-bePerfect"
  },

  "q-04": {
    title:
      "Do you do things (especially for others) that you dont really want to do?",
    category: "q-pleasePeople"
  },

  "q-05": {
    title: "Do you have a tendency to do a lot of things simultaneously?",

    category: "q-hurryUp"
  },

  "q-06": {
    title:
      "Do you hate ‘giving up‘ or ‘giving in‘, always hoping that ‘this time it will work‘?",

    category: "q-tryHard"
  },

  "q-07": {
    title: "Is it important for you to be RIGHT?",

    category: "q-bePerfect"
  },

  "q-08": {
    title: "Is it important for you to be LIKED?",

    category: "q-pleasePeople"
  },

  "q-09": {
    title: "Do you have a tendency to start things and not finish them?",

    category: "q-tryHard"
  },

  "q-10": {
    title: "Do you set unrealistic time limits?",

    category: "q-tryHard"
  },

  "q-11": {
    title: "Are you easily persuaded?",

    category: "q-pleasePeople"
  },

  "q-12": {
    title: "Do you dislike being different?",

    category: "q-pleasePeople"
  },

  "q-13": {
    title:
      "Do you have a tendency to put yourself (or find yourself) in the position of being depended upon? ",

    category: "q-beStrong"
  },

  "q-14": {
    title:
      "Do you feel discomforted (e.g. annoyed, irritated) by small messes or discrepancies such as a spot on a garment or the wallpaper an ornament or tool out of place, a disorderly presentation of work?",

    category: "q-bePerfect"
  },

  "q-15": {
    title:
      "Would you describe yourself as ‘quick‘ and find yourself being impatient with others?",

    category: "q-hurryUp"
  },
  "q-16": {
    title: "Do you hate to be interrupted?",

    category: "q-bePerfect"
  },
  "q-17": {
    title:
      "Do you tend to compare yourself (or your performance) with others and feel inferior or superior accordingly?",

    category: "q-tryHard"
  },

  "q-18": {
    title:
      "Do you find yourself going round in circles with a problem feeling stuck but unable to let go of it?",
    category: "q-tryHard"
  },

  "q-19": {
    title:
      "Do you have a tendency not to realise how tired, or hungry or ill you feel, but instead ‘keep going‘?",
    category: "q-beStrong"
  },

  "q-20": {
    title:
      "Do you tend to talk at the same time as others, or finish their sentences for them?",
    category: "q-hurryUp"
  },

  "q-21": {
    title: "Do you like to explain things in detail and precisely?",
    category: "q-bePerfect"
  },

  "q-22": {
    title: "Do you like to ‘get on with the job‘ rather than talk about it?",
    category: "q-hurryUp"
  },

  "q-23": {
    title: "Do you prefer to do thing on your own?",
    category: "q-beStrong"
  },

  "q-24": {
    title: "Do you dislike conflict?",
    category: "q-pleasePeople"
  },

  "q-25": {
    title:
      "Do you have a tendency to be the rebel or the odd one out in a group?",
    category: "q-tryHard"
  }
};

export const questionsDK = {
  "q-01": {
    title: "Inspirerer mennesker til se udover eksisterende begrænsninger",

    category: "q-vision"
  },
  "q-02": {
    title: "Involverer gruppen i beslutningsprocesser",
    category: "q-authorisation"
  },
  "q-03": {
    title: "Mobiliserer folk til at ‘få tingene gjort‘",
    category: "q-inspire-motivate-others"
  },
  "q-04": {
    title: "Sætter klare mål og krav om kvalitet til gruppens medlemmer",
    category: "q-result-oriented"
  },
  "q-05": {
    title: "Bruger tid på at hjælpe og vejlede gruppens medlemmer",
    category: "q-recognition-feedback"
  },
  "q-06": {
    title:
      "Sikrer at alle gruppens medlemmer oplever de bidrager til beslutningsprocessen",
    category: "q-teambuilding"
  },
  "q-07": {
    title:
      "Står fast på ting du/han/hun tror på - også selvom det indebærer du/han/hun bliver upopulær",
    titlePeer:
      "Står fast på ting han/hun tror på - også selvom det indebærer han/hun bliver upopulær",
    titleMe:
      "Står fast på ting jeg tror på - også selvom det indebærer jeg bliver upopulær",

    category: "q-persistence"
  },
  "q-08": {
    title: "Sikrer sig at din/hans/hendes adfærd svarer til situationen",
    titlePeer: "Sikrer sig at hans/hendes adfærd svarer til situationen",
    titleMe: "Sikrer mig at min adfærd svarer til situationen",
    category: "q-emotional-intelligence"
  },
  "q-09": {
    title: "Føler at der er en god udvikling i din/ hans/hendes karriere mål",
    titlePeer: "Føler at der er en god udvikling i hans/hendes karriere mål",
    titleMe: "Føler at der er en god udvikling i mine karriere mål",
    category: "q-resilience"
  },
  "q-10": {
    title: "Arbejder hårdt for at sikre en balanceret livsstil",

    category: "q-work-life-balance"
  },
  "q-11": {
    title:
      "Sikrer at kundens/klientens tilfredshed er en kerneopgave for gruppen",
    category: "q-external-orientation"
  },
  "q-12": {
    title: "Overvejer hvorledes fremtiden kan påvirke organisationen",
    category: "q-vision"
  },
  "q-13": {
    title: "Lader gruppen vide at du/han/hun har store forventninger til dem",
    titlePeer: "Lader gruppen vide at han/hun har store forventninger til dem",
    titleMe: "Lader gruppen vide at jeg har store forventninger til dem",
    category: "q-authorisation"
  },
  "q-14": {
    title:
      "Forsøger at være en rollemodel for medlemmerne i din/hans/hendes gruppe",
    titlePeer:
      "Forsøger at være en rollemodel for medlemmerne i hans/hendes gruppe",
    titleMe: "Forsøger at være en rollemodel for medlemmerne i min gruppe",

    category: "q-inspire-motivate-others"
  },
  "q-15": {
    title:
      "Holder folk ansvarlige i forhold til deres forpligtigelser og leverancer",
    category: "q-result-oriented"
  },
  "q-16": {
    title:
      "Sikrer at evaluering af gruppens medlemmers er en opsummering af deres regelmæssige feedback",
    category: "q-recognition-feedback"
  },
  "q-17": {
    title:
      "Forsøger at løse konflikter mellem gruppens medlemmer på den måde der styrker gruppen",
    category: "q-teambuilding"
  },
  "q-18": {
    title:
      "Giver ikke bare op på løsninger eller beslutninger som du/han/hun finder nødvendige",
    titlePeer:
      "Giver ikke bare op på løsninger eller beslutninger som han/hun finder nødvendige",
    titleMe:
      "Giver ikke bare op på løsninger eller beslutninger som jeg finder nødvendige",

    category: "q-persistence"
  },
  "q-19": {
    title: "Er god til at fornemme hvad andre føler",
    category: "q-emotional-intelligence"
  },
  "q-20": {
    title:
      "Har nemt ved at håndtere situationer som du/han/hun ikke kan kontrollere",
    titlePeer:
      "Har nemt ved at håndtere situationer som han/hun ikke kan kontrollere",
    titleMe:
      "Har nemt ved at håndtere situationer som jeg ikke kan kontrollere",

    category: "q-resilience"
  },
  "q-21": {
    title: "Har en bred vifte af interesser",
    category: "q-work-life-balance"
  },
  "q-22": {
    title:
      "Sikrer sig at gruppen ved hvad kunden/klienten ønsker og arbejder hårdt og målrettet på at imødekomme disse behov",
    titleMe:
      "Sikrer mig at gruppen ved hvad kunden/klienten ønsker og arbejder hårdt og målrettet på at imødekomme disse behov",

    category: "q-external-orientation"
  },
  "q-23": {
    title:
      "Giver gruppen klar retning for hvor de skal hen og hjælper dem til at komme derhen",
    category: "q-vision"
  },
  "q-24": {
    title:
      "Forsøger at holde gruppen informeret om hvor organisationen er på vej hen",
    category: "q-authorisation"
  },
  "q-25": {
    title:
      "Handler med henblik på at tingene sker og opfordrer andre til at gøre det samme",
    category: "q-inspire-motivate-others"
  },
  "q-26": {
    title:
      "Lægger stor vægt på at gruppens/organisationens værdier og de danner grundlag for gruppens samarbejde som en stærk enhed og definerer dens adfærd",
    category: "q-result-oriented"
  },
  "q-27": {
    title:
      "Forsøger at sikre gruppens kompensation er fair og afspejler individuelle bidrag ",
    category: "q-recognition-feedback"
  },
  "q-28": {
    title:
      "Opfordrer gruppens medlemmer til at opbygge samarbejdsrelationer med hinanden",
    category: "q-teambuilding"
  },
  "q-29": {
    title: "Giver ikke umiddelbart op når tingene ikke ‘bare‘ glider",
    category: "q-persistence"
  },
  "q-30": {
    title: "Anerkender at dine/hans/hendes følelser kan påvirke andre",
    titlePeer: "Anerkender at hans/hendes følelser kan påvirke andre",
    titleMe: "Anerkender at mine følelser kan påvirke andre",
    category: "q-emotional-intelligence"
  },
  "q-31": {
    title: "Forsøger konstant at vedligeholde en sund fysik",
    category: "q-resilience"
  },
  "q-32": {
    title:
      "Leder aktivt efter nye ideer og læring udenfor dit/hans/hendes specifikke ekspertisefelt",
    titlePeer:
      "Leder aktivt efter nye ideer og læring udenfor hans/hendes specifikke ekspertisefelt",
    titleMe:
      "Leder aktivt efter nye ideer og læring udenfor mit specifikke ekspertisefelt",

    category: "q-work-life-balance"
  },
  "q-33": {
    title:
      "Sikrer sig at gruppen er opdateret på hvad der sker indenfor deres område og hvad konkurrenterne gør/ikke gør",
    titleMe:
      "Sikrer mig at gruppen er opdateret på hvad der sker indenfor deres område og hvad konkurrenterne gør/ikke gør",

    category: "q-external-orientation"
  },
  "q-34": {
    title: "Udfordrer ofte status qvo",
    category: "q-vision"
  },
  "q-35": {
    title:
      "Opfordrer gruppens medlemmer til at tage ansvar for de opgaver de tildeles",
    category: "q-authorisation"
  },
  "q-36": {
    title:
      "Er passioneret og energisk i relation til hvad du/han/hun beskæftiger dig/sig med",
    titlePeer:
      "Er passioneret og energisk i relation til hvad han/hun beskæftiger sig med",
    titleMe:
      "Er passioneret og energisk i relation til hvad jeg beskæftiger mig med",

    category: "q-inspire-motivate-others"
  },
  "q-37": {
    title: "Sikrer sig at kvalitets standarder er klare, tydelige og følges",
    category: "q-result-oriented"
  },
  "q-38": {
    title:
      "Forsøger at sikre sig at gruppens medlemmer anerkendes for deres leverancer",
    category: "q-recognition-feedback"
  },
  "q-39": {
    title: "Arbejder hårdt for at sikre dig/sig gruppens tillid",
    titlePeer: "Arbejder hårdt for at sikre sig gruppens tillid",
    titleMe: "Arbejder hårdt for at sikre mig gruppens tillid",
    category: "q-teambuilding"
  },
  "q-40": {
    title: "Rejser dig/sig hurtigt igen efter vanskelige oplevelser",
    titlePeer: "Rejser sig hurtigt igen efter vanskelige oplevelser",
    titleMe: "Rejser mig hurtigt igen efter vanskelige oplevelser",
    category: "q-persistence"
  },
  "q-41": {
    title: "Analyserer dine/sine fejl med henblik på at lære af dem",
    titlePeer: "Analyserer sine fejl med henblik på at lære af dem",
    titleMe: "Analyserer mine fejl med henblik på at lære af dem",

    category: "q-emotional-intelligence"
  },
  "q-42": {
    title:
      "Er i stand til at håndtere det arbejdsmæssige pres og stres konstruktivt",
    category: "q-resilience"
  },
  "q-43": {
    title:
      "Er regelmæssigt engageret i ikke-arbejds relaterede aktiviteter fx sport, hobby, frivilligt arbejde etc.",
    category: "q-work-life-balance"
  },
  "q-44": {
    title:
      "Opfordrer aktivt gruppens medlemmer til at skabe relationer med interessenter udenfor gruppen",
    category: "q-external-orientation"
  },
  "q-45": {
    title: "Er åben for ændringer og nye måder at gøre tingene på",
    category: "q-vision"
  },
  "q-46": {
    title: "Opfordrer gruppen til selv at træffe beslutninger",
    category: "q-authorisation"
  },
  "q-47": {
    title: "Formidler ideer på en klar og forståelig måde",
    category: "q-inspire-motivate-others"
  },
  "q-48": {
    title:
      "Sikrer dig/sig at gruppen forstår hvorfor virksomhedens ‘værdier‘ er essentielle at efterleve for at opnå sine præstationsmål",
    titlePeer:
      "Sikrer sig at gruppen forstår hvorfor virksomhedens ‘værdier‘ er essentielle at efterleve for at opnå sine præstationsmål",
    titleMe:
      "Sikrer mig at gruppen forstår hvorfor virksomhedens ‘værdier‘ er essentielle at efterleve for at opnå sine præstationsmål",

    category: "q-result-oriented"
  },
  "q-49": {
    title:
      "Søger at sikre dig/sig, at ekseptionelle præstationer belønnes retfærdigt",
    titlePeer:
      "Søger at sikre sig, at ekseptionelle præstationer belønnes retfærdigt",
    titleMe:
      "Søger at sikre mig, at ekseptionelle præstationer belønnes retfærdigt",

    category: "q-recognition-feedback"
  },
  "q-50": {
    title: "Sætter gruppens interesser højere end egne personlige mål",
    category: "q-teambuilding"
  },
  "q-51": {
    title:
      "Er indstillet på at tage risici for at sikre at kvalitetsstandarder bliver efterlevet",
    category: "q-persistence"
  },
  "q-52": {
    title:
      "Viser aktivt interesse og omsorg for de mennesker du/han/hun arbejder sammen med",
    titlePeer:
      "Viser aktivt interesse og omsorg for de mennesker han/hun arbejder sammen med",
    titleMe:
      "Viser aktivt interesse og omsorg for de mennesker jeg arbejder sammen med",

    category: "q-emotional-intelligence"
  },
  "q-53": {
    title: "Får mennesker til at åbne op  ved at være nem at snakke med ",
    category: "q-emotional-intelligence"
  },
  "q-54": {
    title: "Har en nær ven som du/han/hun kan betro sig til",
    titlePeer: "Har en nær ven som han/hun kan betro sig til",
    titleMe: "Har en nær ven som jeg kan betro mig til",
    category: "q-work-life-balance"
  },
  "q-55": {
    title:
      "Opfordrer aktivt gruppens medlemmer til at søge informationer eller ideer udenfor organisationen",
    category: "q-external-orientation"
  },
  "q-56": {
    title:
      "Tager hensyn til helheden frem for detaljerne, når der træffes beslutninger.",
    category: "q-vision"
  },
  "q-57": {
    title:
      "Tolererer at de medlemmer i gruppen, der udviser initiativ også laver fejl ",
    category: "q-authorisation"
  },
  "q-58": {
    title: "Er bevidst om at du/han/hun er en vigtig motivator for gruppen",
    titlePeer: "Er bevidst om at han/hun er en vigtig motivator for gruppen",
    titleMe: "Er bevidst om at jeg er en vigtig motivator for gruppen",
    category: "q-inspire-motivate-others"
  },
  "q-59": {
    title:
      "Sørger for, at andre opfører sig i overensstemmelse med  organisationens værdier",
    category: "q-result-oriented"
  },
  "q-60": {
    title: "Giver løbende gruppen konstruktiv feedback",
    category: "q-recognition-feedback"
  },
  "q-61": {
    title: "Glæder sig over meningsforskelle",
    titleMe: "Glæder mig over meningsforskelle",

    category: "q-teambuilding"
  },
  "q-62": {
    title:
      "Forsøger at ændre andres mening hvis du/han/hun mener det er nødvendigt",
    titlePeer:
      "Forsøger at ændre andres mening hvis han/hun mener det er nødvendigt",
    titleMe: "Forsøger at ændre andres mening hvis jeg mener det er nødvendigt",

    category: "q-persistence"
  },
  "q-63": {
    title: "Lader folk tale ud og opfordrer dem til at sige hvad de mener",
    category: "q-dialogue"
  },
  "q-64": {
    title:
      "Har altid styr på dine/sine ansvarområder - både arbejdsmæssigt og privat",
    titlePeer:
      "Har altid styr på sine ansvarområder - både arbejdsmæssigt og privat",
    titleMe:
      "Har altid styr på mine ansvarområder - både arbejdsmæssigt og privat",

    category: "q-resilience"
  },
  "q-65": {
    title: "Sætter prioriteter både i dit/sit private og professionelle liv",
    titlePeer: "Sætter prioriteter både i sit private og professionelle liv",
    titleMe: "Sætter prioriteter både i mit private og professionelle liv",
    category: "q-work-life-balance"
  },
  "q-66": {
    title:
      "Holder dig/sig ajour med begivenheder og udvikling udenfor organisationen som kan påvirke den måde hvorpå der arbejdes - både positivt eller negativt",
    titlePeer:
      "Holder sig ajour med begivenheder og udvikling udenfor organisationen som kan påvirke den måde hvorpå der arbejdes - både positivt eller negativt",
    titleMe:
      "Holder mig ajour med begivenheder og udvikling udenfor organisationen som kan påvirke den måde hvorpå der arbejdes - både positivt eller negativt",

    category: "q-external-orientation"
  },
  "q-67": {
    title:
      "Opfordrer til diversitet og kreativitet - både i gruppen og i meninger",
    category: "q-dialogue"
  },
  "q-68": {
    title: "Er nysgerrig på hvorfor andre har den mening de har",
    category: "q-dialogue"
  },
  "q-69": {
    title: "God til at lytte og stiller spørgsmål for at forstå",
    category: "q-dialogue"
  },
  "q-70": {
    title: "Er bevidst om meningsforskelle og respekterer dig alligevel",
    category: "q-dialogue"
  },
  "q-71": {
    title: "Dømmer dig ikke for din mening - også selvom de er uenige med dig.",
    titlePeer:
      "Dømmer dig ikke for din mening - også selvom han er uenig med dig.",
    titleMe:
      "Dømmer dig ikke for din mening - også selvom jeg er uenig med dig.",
    category: "q-dialogue"
  }
};

export const questionsEN = {
  "q-01": {
    title: "Inspire people to look beyond existing limitation",
    titlePeer: "Inspires people to look beyond existing limitation",
    category: "q-vision"
  },
  "q-02": {
    title: "Involve the team in decision making",
    titlePeer: "Involves the team in decision making",
    category: "q-authorisation"
  },
  "q-03": {
    title: "Mobilise people to get things done",
    titlePeer: "Mobilises people to get things done",
    category: "q-inspire-motivate-others"
  },
  "q-04": {
    title: "Set clear performance standards and goals for team members",
    titlePeer: "Sets clear performance standards and goals for team members",
    category: "q-result-oriented"
  },
  "q-05": {
    title: "Spend time mentoring and guiding team members",
    titlePeer: "Spends time mentoring and guiding team members",
    category: "q-recognition-feedback"
  },
  "q-06": {
    title:
      "Make sure that all team members feel they contribute to the decision-making process",
    titlePeer:
      "Makes sure that all team members feel they contribute to the decision-making process",

    category: "q-teambuilding"
  },
  "q-07": {
    title:
      "Stand up for things you/s/he believes in, even if this makes you/him/her unpopular",
    titlePeer:
      "Stands up for things s/he believes in, even if this makes him/her unpopular",
    titleMe:
      "Stand up for things I believe in, even if this makes me unpopular",
    category: "q-persistence"
  },
  "q-08": {
    title: "Make sure that behaviour is appropriate to the situation",
    titlePeer: "Makes sure that behaviour is appropriate to the situation",
    category: "q-emotional-intelligence"
  },
  "q-09": {
    title:
      "Are progressing well in the achievement of your/his/her career goals",
    titlePeer: "is progressing well in the achievement of his/her career goals",
    titleMe: "Am progressing well in the achievement of my career goals",

    category: "q-resilience"
  },
  "q-10": {
    title: "Work hard to maintain a balanced lifestyle",
    titlePeer: "Works hard to maintain a balanced lifestyle",
    category: "q-work-life-balance"
  },
  "q-11": {
    title:
      "Make sure that customer/client satisfaction is a core team objective",
    titlePeer:
      "Makes sure that customer/client satisfaction is a core team objective",

    category: "q-external-orientation"
  },
  "q-12": {
    title: "Consider how future events will affect the organisation",
    titlePeer: "Considers how future events will affect the organisation",

    category: "q-vision"
  },
  "q-13": {
    title: "Let the team know that your/s/he has high expectations of them",
    titlePeer: "Lets the team know that s/he has high expectations of them",
    titleMe: "Let the team know that I have high expectations of them",
    category: "q-authorisation"
  },
  "q-14": {
    title: "Try to be a role model for your/his/her people",
    titlePeer: "Tries to be a role model for his/her people",
    titleMe: "Try to be a role model for my people",
    category: "q-inspire-motivate-others"
  },
  "q-15": {
    title: "Make people accountable for their commitments and deadlines",
    titlePeer: "Makes people accountable for their commitments and deadlines",
    category: "q-result-oriented"
  },
  "q-16": {
    title:
      "Make sure that team members performance reviews are a summary of ongoing feedback",
    titlePeer: "Makes people accountable for their commitments and deadlines",
    category: "q-recognition-feedback"
  },
  "q-17": {
    title:
      "Try to resolve conflict among team members in a way that strengthens the team",
    titlePeer:
      "Tries to resolve conflict among team members in a way that strengthens the team",

    category: "q-teambuilding"
  },
  "q-18": {
    title:
      "Don't easily give up on actions or decisions which you/s/he believes are necessary",
    titlePeer:
      "Doesn't easily give up on actions or decisions which s/he believes are necessary",
    titleMe:
      "Don't easily give up on actions or decisions which I believe are necessary",

    category: "q-persistence"
  },
  "q-19": {
    title: "Are good at recognising what others are feeling",
    titlePeer: "Is good at recognising what others are feeling",
    titleMe: "Am good at recognising what others are feeling",
    category: "q-emotional-intelligence"
  },
  "q-20": {
    title: "Find it easy to cope with situations you/s/he cannot control",
    titlePeer: "Finds it easy to cope with situations s/he cannot control",
    titleMe: "Find it easy to cope with situations I cannot control",
    category: "q-resilience"
  },
  "q-21": {
    title: "Have a wide range of interests",
    titlePeer: "Has a wide range of interests",
    category: "q-work-life-balance"
  },
  "q-22": {
    title:
      "Make sure the team knows what clients/customers want and works hard to meet their needs",
    titlePeer:
      "Makes sure the team knows what clients/customers want and works hard to meet their needs",

    category: "q-external-orientation"
  },
  "q-23": {
    title:
      "Give the team clear direction on where they are going, and guidance on how to get there",
    titlePeer:
      "Gives the team clear direction on where they are going, and guidance on how to get there",

    category: "q-vision"
  },
  "q-24": {
    title:
      "Make an effort to keep the team informed about where the organization is going",
    titlePeer:
      "Makes an effort to keep the team informed about where the organization is going",

    category: "q-authorisation"
  },
  "q-25": {
    title: "Take action to get things done and encourage others to do the same",
    titlePeer:
      "Takes action to get things done and encourages others to do the same",
    category: "q-inspire-motivate-others"
  },
  "q-26": {
    title:
      "Place great emphasis on the team and corporate values as a basis for uniting the team and guidelines for how to behave",
    titlePeer:
      "Places great emphasis on the team and corporates values as a basis for uniting the team and guidelines for how to behave",

    category: "q-result-oriented"
  },
  "q-27": {
    title:
      "Try to ensure that compensation for the team is fair, and also reflects individual efforts",
    titlePeer:
      "Tries to ensure that compensation for the team is fair, and also reflects individual efforts",

    category: "q-recognition-feedback"
  },
  "q-28": {
    title:
      "Encourage team members to build collaborative relationships with one another",
    titlePeer:
      "Encourages team members to build collaborative relationships with one another",

    category: "q-teambuilding"
  },
  "q-29": {
    title:
      "Are not easily discouraged when things don‘t immediately go your/his/her way",
    titlePeer:
      "Is not easily discouraged when things don‘t immediately go his/her way",
    titleMe:
      "Am not easily discouraged when things don‘t immediately go my way",

    category: "q-persistence"
  },
  "q-30": {
    title: "Recognise how your/his/her emotions can affect others",
    titlePeer: "Recognises how his/her emotions can affect others",
    titleMe: "Recognise how my emotions can affect others",
    category: "q-emotional-intelligence"
  },
  "q-31": {
    title: "Consistently manage to stay physically healthy",
    titlePeer: "Consistently manages to stay physically healthy",
    category: "q-resilience"
  },
  "q-32": {
    title:
      "Are actively looking for new ideas and learning opportunities outside of your/his/her specific field of expertise",
    titlePeer:
      "Is actively looking for new ideas and learning opportunities outside of his/her specific field of expertise",
    titleMe:
      "Am actively looking for new ideas and learning opportunities outside of my specific field of expertise",

    category: "q-work-life-balance"
  },
  "q-33": {
    title:
      "Makes sure that the team keeps up to date with what is happening in the field and with what competitors are/are not doing",
    titleMe:
      "Make sure that the team keeps up to date with what is happening in the field and with what competitors are/are not doing",

    category: "q-external-orientation"
  },
  "q-34": {
    title: "Often challenges the status quo",
    titleMe: "Often challenge the status quo",

    category: "q-vision"
  },
  "q-35": {
    title:
      "Encourage the team members to take full responsibility for tasks delegated to them",
    titlePeer:
      "Encourages the team members to take full responsibility for tasks delegated to them",

    category: "q-authorisation"
  },
  "q-36": {
    title: "Are passionate and energetic in relation to what you/s/he do(es)",
    titlePeer: "Is passionate and energetic in relation to what s/he does",
    titleMe: "Am passionate and energetic in relation to what I do",

    category: "q-inspire-motivate-others"
  },
  "q-37": {
    title: "Make sure that performance standards are clear and adhered to",
    titlePeer: "Makes sure that performance standards are clear and adhered to",

    category: "q-result-oriented"
  },
  "q-38": {
    title: "Try to make sure that the teams achievements are recognised",
    titlePeer: "Tries to make sure that the teams achievements are recognised",

    category: "q-recognition-feedback"
  },
  "q-39": {
    title: "Work hard to earn the trust of team members",
    titlePeer: "Works hard to earn the trust of team members",
    category: "q-teambuilding"
  },
  "q-40": {
    title: "Bounce back easily after going through a difficult experience",
    titlePeer: "Bounces back easily after going through a difficult experience",
    category: "q-persistence"
  },
  "q-41": {
    title: "Analyse your/his/her mistakes in order to learn from them",
    titlePeer: "Analyses his/her mistakes in order to learn from them",
    titleMe: "Analyse my mistakes in order to learn from them",
    category: "q-emotional-intelligence"
  },
  "q-42": {
    title: "Find the stress and pressures of work very manageable",
    titlePeer: "Finds the stress and pressures of work very manageable",
    category: "q-resilience"
  },
  "q-43": {
    title:
      "Regularly engage in non-work-related activities (i.e. Sports, hobbies, volunteer activities etc.)",
    titlePeer:
      "Regularly engages in non-work-related activities (i.e. Sports, hobbies, volunteer activities etc.)",

    category: "q-work-life-balance"
  },
  "q-44": {
    title:
      "Actively encourage the team to form relationships with stakeholders outside the team",
    titlePeer:
      "Actively encourages the team to form relationships with stakeholders outside the team",

    category: "q-external-orientation"
  },
  "q-45": {
    title: "Are open to change and new ways of doing things",
    titlePeer: "Is open to change and new ways of doing things",
    titleMe: "Am open to change and new ways of doing things",

    category: "q-vision"
  },
  "q-46": {
    title: "Encourage the team to make their own decisions",
    titlePeer: "Encourages the team to make their own decisions",
    titleMe: "Encourage the team to make their own decisions",
    category: "q-authorisation"
  },
  "q-47": {
    title: "Convey ideas in a clear and understandable way",
    titlePeer: "Conveys ideas in a clear and understandable way",

    category: "q-inspire-motivate-others"
  },
  "q-48": {
    title:
      "Ensure that the team understand why ‘living the values‘ is essential for achieving performance objectives",
    titlePeer:
      "Ensures that the team understand why ‘living the values‘ is essential for achieving performance objectives",

    category: "q-result-oriented"
  },
  "q-49": {
    title:
      "Try to make sure that outstanding performance is rewarded appropriately",
    titlePeer:
      "Tries to make sure that outstanding performance is rewarded appropriately",

    category: "q-recognition-feedback"
  },
  "q-50": {
    title: "Put the interest of the group before your/his/her personal goals",
    titlePeer: "Puts the interest of the group before his/her personal goals",
    titleMe: "Put the interest of the group before my own personal goals",

    category: "q-teambuilding"
  },
  "q-51": {
    title:
      "Are prepared to take risks to ensure that standards of excellence are maintained",
    titlePeer:
      "is prepared to take risks to ensure that standards of excellence are maintained",
    titleMe:
      "Am prepared to take risks to ensure that standards of excellence are maintained",

    category: "q-persistence"
  },
  "q-52": {
    title:
      "Actively show an interest in and care for the people you/he/she works with",
    titlePeer:
      "Actively shows an interest in and cares for the people he/she works with",
    titleMe: "Actively show an interest in and care for the people I work with",

    category: "q-emotional-intelligence"
  },
  "q-53": {
    title: "Get people to open up by being easy to approach",
    titlePeer: "Gets people to open up by being easy to approach",
    category: "q-resilience"
  },
  "q-54": {
    title: "Have a close friend in whom you/s/he can confide",
    titlePeer: "Has a close friend in whom s/he can confide",
    titleMe: "Have a close friend in whom I can confide",
    category: "q-work-life-balance"
  },
  "q-55": {
    title:
      "Actively encourages the team to look outside the organisation for information/ideas",
    titleMe:
      "Actively encourage the team to look outside the organisation for information/ideas",

    category: "q-external-orientation"
  },
  "q-56": {
    title:
      "Consider the whole situation rather than the details only when making decisions",
    titlePeer:
      "Considers the whole situation rather than the details only when making decisions",

    category: "q-vision"
  },
  "q-57": {
    title: "Tolerate mistakes by team members who are taking the initiative",
    titlePeer:
      "Tolerates mistakes by team members who are taking the initiative",

    category: "q-authorisation"
  },
  "q-58": {
    title:
      "See yourself/him/herself as an important source of motivation for the team",
    titlePeer:
      "Sees him/herself as an important source of motivation for the team",
    titleMe: "See myself as an important source of motivation for the team",

    category: "q-inspire-motivate-others"
  },
  "q-59": {
    title:
      "Make sure that others behave according to the values of the organisation",
    titlePeer:
      "Makes sure that others behave according to the values of the organisation",

    category: "q-result-oriented"
  },
  "q-60": {
    title: "Provide the team with ongoing constructive feedback",
    titlePeer: "Provides the team with ongoing constructive feedback",
    category: "q-recognition-feedback"
  },
  "q-61": {
    title: "Welcome differences of opinion",
    titlePeer: "Welcomes differences of opinion",
    category: "q-teambuilding"
  },
  "q-62": {
    title:
      "When you/s/he believes it‘s necessary, tries to change the opinions of others",
    titlePeer:
      "Tries to change the opinions of others, when s/he believes it‘s necessary,",
    titleMe:
      "Try to change the opinions of others, when I believes it‘s necessary,",

    category: "q-persistence"
  },
  "q-63": {
    title:
      "Let people finish what they want to say and encourages them to speak their mind",
    titlePeer:
      "Lets people finish what they want to say and encourages them to speak their mind",

    category: "q-dialogue"
  },
  "q-64": {
    title:
      "Consistently stay on top of your/his/her responsibilities at work and at home",
    titlePeer:
      "Consistently stays on top of his/her responsibilities at work and at home",
    titleMe:
      "Consistently stay on top of my responsibilities at work and at home",

    category: "q-resilience"
  },
  "q-65": {
    title: "Set priorities in both your/his/her private and professional life",
    titlePeer: "Sets priorities in both his/her private and professional life",
    titleMe: "Set priorities in both my private and professional life",
    category: "q-work-life-balance"
  },
  "q-66": {
    title:
      "Actively keep on top of developments happening outside the organisation that might impact or aid the way we do things",
    titlePeer:
      "Actively keeps on top of developments happening outside the organisation that might impact or aid the way we do things",

    category: "q-external-orientation"
  },
  "q-67": {
    title: "Encourage diversity and creativity in teams and opinions",
    titlePeer: "Encourages diversity and creativity in teams and opinions",

    category: "q-dialogue"
  },
  "q-68": {
    title: "Are curious to hear why others have the opinion they have",
    titlePeer: "Is curious to hear why others have the opinion they have",
    titleMe: "Am curious to hear why others have the opinion they have",

    category: "q-dialogue"
  },
  "q-69": {
    title: "Good at listening and ask questions in order to understand",
    titlePeer: "Is good at listening and ask questions in order to understand",
    titleMe: "Am good at listening and ask questions in order to understand",
    category: "q-dialogue"
  },
  "q-70": {
    title:
      "Are conscious of differences of opinion and respects people nevertheless",
    titlePeer:
      "Is conscious of differences of opinion and respects people nevertheless",
    titleMe:
      "Am conscious of differences of opinion and respects people nevertheless",

    category: "q-dialogue"
  },
  "q-71": {
    title:
      "Dont judge people for their opinion though you/he/she might disagree",
    titlePeer:
      "Doesn't judge people for their opinion though he/she might disagree",
    titleMe: "Dont judge people for their opinion though I might disagree",

    category: "q-dialogue"
  }
};

export const questionsDK_TA = {
  "q-01": {
    title: "Altid - aldrig - bør - burde - ikke - skal - skal ikke",
    category: "q-critical-parent"
  },
  "q-02": {
    title:
      "Det skal nok gå - Bare rolig - Pas nu på -Er der noget jeg kan gøre? - Kan jeg hjælpe?",
    category: "q-critical-parent"
  },
  "q-03": {
    title:
      "Hvad skete der? - Hvorfor tror du det? - Hvem var involveret? - Hvad er situationen nu? - Hvornår ved vi mere?",
    category: "q-caring-parent"
  },
  "q-04": {
    title:
      "Wow! - Ja, lad os gøre det! - Bare kør løs! - Alle tiders - Fantastisk!",
    category: "q-caring-parent"
  },
  "q-05": {
    title:
      "Jeg er bange - jeg vil ikke tale om det - jeg vil gerne gå nu - jeg kan ikke klare det - Det er for meget for mig - Jeg kan ikke overskue det - Der er ingen der bekymrer sig om  - [stilhed]",
    category: "q-parent"
  },
  "q-06": {
    title:
      "Jeg er da ligeglad! - Du kan hoppe og springe! - ... .. din! - Jeg har fået nok af ...! - Hvem tror du egentlig du er! - Skrub af! - Forsvind!",
    category: "q-parent"
  },
  "q-07": {
    title:
      "Det er jo latterligt! - Vær ikke dum! - Hvad er der galt med dig? - Hvis du ikke kan gøre det rigtigt, så lad vær! - Sagde jeg ikke du skulle gøre det!",
    category: "q-natural-child"
  },
  "q-08": {
    title:
      "Stakkels dig - Det er godt - Godt gjort - Er du ikke stolt? - Super - Alletiders - Godt arbejde!",
    category: "q-natural-child"
  },

  "q-09": {
    title:
      "Jeg har brug for at vide noget mere - måske du kan hjælpe - Jeg tror det er svaret - Det her er hvad jeg føler  - Jeg forstår dine argumenter",
    category: "q-withdrawen-child"
  },
  "q-10": {
    title:
      "Også mig! - Jeg elsker det! - Vi er et godt hold! - Lad os gøre det snart igen",
    category: "q-withdrawen-child"
  },
  "q-11": {
    title:
      "Undskyld - lad mig være  - jeg mente det ikke - hvis bare  - jeg kunne ikke gøre for det",
    category: "q-angry-child"
  },
  "q-12": {
    title:
      "Jeg vil ikke - Det kommer aldrig til at ske - Det er da noget du tror - Pas dig selv - Ikke en chance - No way!",
    category: "q-angry-child"
  }
};

export const questionsEN_TA = {
  "q-01": {
    title: "Always - never - shall - should not - must - must not",
    category: "q-critical-parent"
  },
  "q-02": {
    title:
      "Everything will be all right - Don't worry - Be careful -Is there anything I can do? - Can I help?",
    category: "q-critical-parent"
  },
  "q-03": {
    title:
      "What happened? - Why do you think that? - Who was involved? - How is the situation right now? - When do we know more?",
    category: "q-caring-parent"
  },
  "q-04": {
    title: "Wow! - Yes, let's do it! - Just keep going! - Great - Fantastic!",
    category: "q-caring-parent"
  },
  "q-05": {
    title:
      "I'm scared - I don't want to take about it - I want to leave - I can't handle it - It's too much for me - I can't cope with it - Nobody worries about  - [silence]",
    category: "q-parent"
  },
  "q-06": {
    title:
      "I don't care! - You can go to blazes for all I care - ... .. you! - I've had enough of ...! - Who do you think you are! - Get lost! - Go away!",
    category: "q-parent"
  },
  "q-07": {
    title:
      "That's ridiculous! - Don't be stupid! - What's wrong with you? - If you can't do it right, then don't! - Didn't I tell you that you should do it!",
    category: "q-natural-child"
  },
  "q-08": {
    title:
      "Poor you - That's good - Well done - Aren't you proud? - Super - Great - Good job!",
    category: "q-natural-child"
  },

  "q-09": {
    title:
      "I have to know a bit more - Maybe you could help - I think that's the answer - That's what I feel  - I understand your arguments",
    category: "q-withdrawen-child"
  },

  "q-10": {
    title: "Me too - I love it! - We're a good team! - Let's do it again soon",
    category: "q-withdrawen-child"
  },
  "q-11": {
    title:
      "Sorry - Leave me alone - I didn't mean it - If just  - I couldn't help it",
    category: "q-angry-child"
  },

  "q-12": {
    title:
      "I don't want to - That will never happen - That's something you think - Mind your business - Not a chance - No way!",
    category: "q-angry-child"
  }
};

export const categories = {
  twentyfivesections: {
    "q-bePerfect": {
      en: "Be Perfect",
      dk: "Vær Perfekt"
    },
    "q-pleasePeople": {
      en: "Please People",
      dk: "Tilfredsstil Folk"
    },
    "q-hurryUp": {
      en: "Hurry Up",
      dk: "Skynd dig"
    },
    "q-beStrong": {
      dk: "Vær Stærk",
      en: "Be Strong"
    },
    "q-tryHard": {
      dk: "Vær Umage",
      en: "Try Hard"
    }
  },
  twelvesections: {
    "q-bePerfect": {
      en: "Be Perfect",
      dk: "Vær Perfekt"
    },
    "q-pleasePeople": {
      en: "Please People",
      dk: "Tilfredsstil Folk"
    },
    "q-hurryUp": {
      en: "Hurry Up",
      dk: "Skynd dig"
    },
    "q-beStrong": {
      dk: "Vær Stærk",
      en: "Be Strong"
    },
    "q-tryHard": {
      dk: "Vær Umage",
      en: "Try Hard"
    }
  },
  360: {
    "q-vision": {
      dk: "Skabe en Vision",
      en: "Create a vision"
    },
    "q-authorisation": {
      dk: "Autorisering / Bemyndigelse",
      en: "Authorisation"
    },
    "q-inspire-motivate-others": {
      dk: "Inspirer andre",
      en: "Inspire & Motivate Others"
    },
    "q-result-oriented": {
      dk: "Fokus på resultater",
      en: "Result Oriented"
    },
    "q-recognition-feedback": {
      dk: "Anerkendelse og  Feedback",
      en: "Recognition & Feedback"
    },
    "q-teambuilding": {
      dk: "Teambuilding",
      en: "Teambuilding"
    },
    "q-persistence": {
      dk: "Vedholdende",
      en: "Persistence"
    },
    "q-emotional-intelligence": {
      dk: "Emotional Intelligens",
      en: "Emotional Intelligence"
    },
    "q-resilience": {
      dk: "Modstandskraft",
      en: "Resilience"
    },
    "q-work-life-balance": {
      dk: "Balance mellem arbejde og fritid",
      en: "Work-Life Balance"
    },
    "q-external-orientation": {
      dk: "Orientering imod omverdenen",
      en: "External Orientation"
    },
    "q-dialogue": {
      dk: "Dialog",
      en: "Dialogue"
    }
  },

  profile: {
    "q-critical-parent": {
      dk: "Kritisk forældre",
      en: "Critical parent"
    },
    "q-caring-parent": {
      dk: "Omsorgsfuld forældre",
      en: "Caring Parent"
    },
    "q-parent": {
      dk: "Voksen",
      en: "Adult"
    },
    "q-natural-child": {
      dk: "Naturligt barn",
      en: "Natural Child"
    },
    "q-withdrawen-child": {
      dk: "Tilbagetrukket barn",
      en: "Withdrawn Child"
    },
    "q-angry-child": {
      dk: "Vredt barn",
      en: "Angry child"
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/Evaluation/questions.js